import { useQuery } from '@apollo/client';
import { FeatureFlagsQueryResult, GET_FEATURE_FLAGS_QUERY } from '../services/feature-flags';
import { FeatureFlag } from '../services/models/feature-flags';

// Flags are server-driven but static for the lifetime of the app session
// (legacy fetched them once at dashboard mount), so read through the cache.
export const useFeatureFlags = () => {
  const { data, loading } = useQuery<FeatureFlagsQueryResult>(GET_FEATURE_FLAGS_QUERY, {
    fetchPolicy: 'cache-first',
  });

  return { flags: data?.viewer?.featureFlags, loading };
};

export const useFeatureFlag = (featureFlag: FeatureFlag): boolean => {
  const { flags } = useFeatureFlags();
  return !!flags?.[featureFlag];
};
